export const WORK_ORDER_ONBOARDING_V2 = "Work Order Onboarding V2";
export const WORK_ORDER_ONBOARDING_V2_STEPS = {
  ENTRY: "Entry",
  ITEM_ONBOARD_SUCCESS: "Item Onboard Success",
  ITEM_ONBOARD_FAILED: "Item Onboard Failed"
};
